<template>
  <AppSection class="relative">
    <AppContainer class="heading">
      <AppThirdLayout class="layout">
        <AppHeaderWithImg 
          :text="$tt('blog.overview_title')"
          src="/images/news-magazine-illustration.jpg"
          :alt="$tt('page.testimonials.megaphone_img')"
          row
        />
        <BlogCategories variant="menu" hide-title class="categories self-end" />
      </AppThirdLayout>
    </AppContainer>
    <AppCarousel
      :breakpoints="{
        851: { itemsToShow: 2 },
        1000: { itemsToShow: 2.6 },
        1250: { itemsToShow: 3.5 },
        1550: { itemsToShow: 3.9 },
        1800: { itemsToShow: 4.8 },
        1900: { itemsToShow: 4.9 },
        2000: { itemsToShow: 5 },
      }"
      snap-align="start"
      wrap-around navigation elevated
    >
      <AppCarouselSlide v-for="post in posts" :key="post.id">
        <ArticleCard :post has-excerpt white />
      </AppCarouselSlide>
    </AppCarousel>
  </AppSection>
</template>

<script setup lang="ts">
import { AppCarousel } from '#components';

useSchemaOrg('blog');

const search = ref('');

const { getPosts } = useWordpress();
const { data: posts } = await useAsyncData('posts', () => getPosts({ search: search.value }));
</script>

<style scoped lang="scss">
@media (min-width: 851px) {
  .heading {
    margin-bottom: calc(-1 * var(--space-6));
  }
  .search {
    width: 100%;
  }
}
@media (max-width: 850px) {
  .heading {
    margin-bottom: calc(-1 * var(--space-6));
  }
  .layout {
    gap: var(--space-2) !important;
  }
  .categories {
    align-self: start;
    width: 100%;
  }
}
</style>